module.exports = __webpack_public_path__ + "static/media/courses.56a1cfb5.svg";